import ControllerBase from '../../../../global/js/ControllerBase';
import { AtomPlayButtonEvents } from './a-play-button.events';

export default class ControllerPlayButton extends ControllerBase {

	constructor(element: HTMLElement) {
		super(element);

		// watch for button clicks
		this.observeButtonClick();
	}

	/**
	 * Observe button clicks
	 */
	private observeButtonClick(): void {
		this.$element.removeEventListener('click', this.handleButtonClick);
		this.$element.addEventListener('click', e => this.handleButtonClick(e));
	}

	private handleButtonClick(e: MouseEvent): void {
		e.preventDefault();
		e.stopPropagation();

		this.dispatchCustomEvent(AtomPlayButtonEvents.playButtonClicked, e);
	}
}
